module.exports = __webpack_public_path__ + "static/media/word-icon.a245b8f5.svg";